import { FormField, FormFieldProps } from '@velocity/ui';
import React from 'react';

/* Props every Form*Field forwards to Velocity's FormField (hint, tooltip, ...) */
export type FormFieldShellProps = Pick<
  FormFieldProps,
  | 'hideLabel'
  | 'hint'
  | 'tooltip'
  | 'required'
  | 'disabled'
  | 'readOnly'
  | 'className'
> & {
  /** Field name - also used for the FormField id */
  name: string;
  label: React.ReactNode;
  /** Validation error message (yup / react-hook-form) */
  errorMessage?: string;
};

type Props = FormFieldShellProps & { children: React.ReactElement };

/*
 * Figma (node 708:7382): label 20px line-height + 8px to the input.
 * Velocity's FormField only leaves 2px, so the label margin is overridden and
 * fields without a visible label get the same offset as padding so inputs in a
 * `FormRow` stay aligned (Velocity renders a hidden label as an absolutely
 * positioned sr-only span that takes no space).
 */
const LABEL_SPACING = '[&>div:first-child]:mb-2!';
const HIDDEN_LABEL_SPACING = 'pt-7';

const FormFieldShell: React.FC<Props> = ({
  name,
  label,
  hideLabel,
  className = '',
  children,
  ...rest
}) => (
  <FormField
    {...rest}
    id={name}
    label={label}
    hideLabel={hideLabel}
    liveHelperText
    className={`${hideLabel ? HIDDEN_LABEL_SPACING : LABEL_SPACING} ${className}`}
  >
    {children}
  </FormField>
);

export default FormFieldShell;
